import React, { ReactElement, ReactNode } from "react";
import Head from "next/head";
import Footer from "@components/shared/footer";
import Modal from "@components/shared/modal";
import CloseIcon from "@components/svg/closeIcon";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import { useModal } from "@hooks/useModalContext";
import Header from "@components/shared/header";
import FullCoverageWarrantyLogo from "@components/fullcoveragewarranty/logo";
import Mobile from "@components/shared/blogPost/sideWidget/mobile";

export default function FullCoverageWarrantyWrapper({
    children,
    headerBoxShadow = "",
    removePadding = false,
}: {
    children: ReactNode;
    headerBoxShadow?: string;
    removePadding?: boolean;
}): ReactElement {
    const { modal, closeModal } = useModal();

    const handleClose = () => {
        closeModal();
    };

    const { active: modalActive, content: modalContent } = modal;

    const getModalContent = () => {
        switch (modalContent) {
            case "privacy":
                return (
                    <PrivacyPolicy
                        category="Warranty"
                        domain="FullCoverageWarranty.com"
                    />
                );
            case "terms":
                return (
                    <TermsAndConditions
                        category="Warranty"
                        domain="FullCoverageWarranty.com"
                    />
                );
            case "sideWidget":
                return <Mobile />;
            default:
                return null;
        }
    };

    return (
        <>
            <Head>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" />

                <link
                    href="https://fonts.googleapis.com/css2?family=Lato:wght@400;700&family=Open+Sans:wght@400;700&family=Poppins:wght@400;500;600;700&family=Roboto:wght@400;700&display=swap"
                    rel="stylesheet"
                ></link>
            </Head>

            <div style={{ fontFamily: `'Poppins', sans-serif` }}>
                <Header
                    slogan="best warranty companies in your area"
                    boxShadow={headerBoxShadow}
                >
                    <FullCoverageWarrantyLogo />
                </Header>
                <main
                    className={`max-w-7xl mx-auto block  ${
                        removePadding ? "" : "px-4"
                    } `}
                >
                    {children}
                </main>
                <Footer />

                <Modal
                    onClose={handleClose}
                    active={modalActive}
                    closeIcon={<CloseIcon />}
                    backdropClosable
                    modalStyles={{
                        display: "flex",
                        flexDirection: "column",
                        maxHeight:
                            modalContent === "sideWidget" ? "80vh" : "100%",
                    }}
                    modalClassName="h-[90vh] rounded"
                    bodyStyles={{ overflowY: "scroll" }}
                    width={900}
                    header={
                        modalContent === "privacy"
                            ? "Privacy Policy"
                            : modalContent === "terms"
                            ? "Terms and Conditions"
                            : modalContent === "sideWidget"
                            ? "Contents"
                            : undefined
                    }
                >
                    {getModalContent()}
                </Modal>
            </div>
        </>
    );
}
